import { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext.js";
import { Navigate, useLocation } from "react-router-dom"; // Import only what's needed
import { getFirestoreData } from "../../firebase/Firestore.js";

const ProtectedRoute = ({ children, redirectTo = "/login", message = null, requireAdmin = false }) => {
  const { userLoggedIn, currentUser } = useAuth();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [userExists, setUserExists] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkUserAccess = async () => {
      if (currentUser) {
        const data = await getFirestoreData("Users", currentUser.uid, "", null);
        setUserExists(!!data);
        setIsAdmin(data?.admin === true);
      } else {
        setUserExists(false);
        setIsAdmin(false);
      }
      setLoading(false);
    };

    checkUserAccess();
  }, [currentUser]);

  if (!userLoggedIn) {
    return (
      <Navigate
        to={redirectTo}
        state={{ message, from: location }}
        replace
      />
    );
  }

  if (loading) {
    // Optional: Add a loading spinner while checking user existence
    return <div>Loading...</div>;
  }

  if (!userExists) {
    return (
      <Navigate
        to="/complete-profile"
        state={{ message: "Please complete your profile before proceeding", from: location }}
        replace
      />
    );
  }

  if (requireAdmin && !isAdmin) {
    return (
      <Navigate
        to="/"
        state={{ message: "You do not have permission to access this page" }}
        replace
      />
    );
  }

  return children; // Render the protected content
};

export default ProtectedRoute;
